import axios from "axios";
import vue from "../../main";
import Cookie from "js-cookie";
import { GetAuthToken } from "rj-server-auth-token";
import {
  handleAxiosAndRouterToken,
  PARTNERS_TOKEN
} from "../../utils/loginUtils";
// 接口白名单
const whiteList = ["/partners-center-admin/userAuthority/token/generate"];
const instance = axios.create({
  withCredentials: true,
  baseURL: window._env_.BASE_APIS,
  headers: { "Content-Type": "application/json" }
});

// http请求拦截
instance.interceptors.request.use(
  async config => {
    config.headers.sysId = "ec9dfcb4f37e4e728117ebdb531ff04c";
    config.headers["web-sign-server-auth"] = GetAuthToken({
      sysId: "ec9dfcb4f37e4e728117ebdb531ff04c",
      accessKeySecret: "883D1B60740741E3A22232F7CCF31417"
    });
    if (!whiteList.includes(config.url)) {
      await handleAxiosAndRouterToken();
      // 这个地方的时候必有token
      config.headers["token"] = Cookie.get(PARTNERS_TOKEN);
    }
    if (config.method === "get") {
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      };
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
// http响应拦截器
instance.interceptors.response.use(
  res => {
    switch (res.data.status) {
      case "200":
        break;
      case "403":
        window.location.href = "/403";
        break;
      case "88888":
        if (window._env_.ENV === "pro") {
          window.location.href = `https://account.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        } else {
          window.location.href = `https://account-uat.ruijie.com?r=${encodeURIComponent(
            window.location.href
          )}`;
        }
        break;
      default:
        vue.$notify({
          title: res.data.err,
          type: "error"
        });
    }
    return res;
  },
  error => {
    // if (error.response.status && error.response.status === 504) {
    //   vue.$message.error("Gateway Timeout, Please Try Again Later.");
    // }
  }
);
// axios 具体使用 请参考 https://github.com/axios/axios
export default {
  instance: instance,
  getAliTempKeyInfo: params =>
    instance.post(`/partners-common-service/file/generate-token`, params), // 获取AliOss必要参数
  saveALiFileInfo: params =>
    instance.post("/partners-common-service/file/file-content", params), // 保存阿里文件记录
  getAliOSSDownloadInfo: id =>
    instance.get(`/partners-common-service/file/detail/getAllFile/${id}`), // 获取阿里文件的下载信息
  uploadFileByContractId: params =>
    instance.post("/partners-oversea-ces/attachment/uploadDocumento", params), // 上传合同附件
  printContractPDF: contractId =>
    instance.get(`/partners-oversea-ces/contract/printContractPDF`, {
      params: { contractId } // 下载PO
    })
};



// WEBPACK FOOTER //
// ./src/api/fileAxios/fileAxios.js